import { Typography } from "@mui/material";

const CountryListItem = ({ countryName }: { countryName: string }) => {
    return (
        <Typography>
            <strong>{countryName}</strong>
        </Typography>
    );
};

export default CountryListItem;
